import { Tooltip } from "@mui/material"
import { InfoOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { AdjustmentHistoryDescription } from "@/graphql/codegen/graphql"

interface InventoryAdjustmentHistoryDescriptionCellProps {
  description: AdjustmentHistoryDescription
}

export const InventoryAdjustmentHistoryDescriptionCell: FC<InventoryAdjustmentHistoryDescriptionCellProps> = ({
  description,
}) => (
  <div className='flex flex-col gap-y-1'>
    {description.akrochemDescription && (
      <div className='flex items-center gap-x-1'>
        <span className='font-medium text-gray-900'>{description.akrochemDescription}</span>
        <Tooltip title='Akrochem Description' placement='right' arrow>
          <InfoOutlined className='text-gray-600' fontSize='small' />
        </Tooltip>
      </div>
    )}
    {description.supplierDescription && (
      <div className='flex items-center gap-x-1'>
        <span>{description.supplierDescription}</span>
        <Tooltip title='Supplier Description' placement='right' arrow>
          <InfoOutlined className='text-gray-600' fontSize='small' />
        </Tooltip>
      </div>
    )}
  </div>
)
